import { useUser } from "contexts/userContext/userContext";
import { useRef, useEffect } from "react";

const AudioElement = () => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const { getUserData, isTokenExist } = useUser();

  useEffect(() => {
    if (!isTokenExist || getUserData()?.SoundNotification) {
      const audioElement = audioRef.current;
      if (!audioElement) return;
      audioElement.volume = 0.25;
      audioElement.play();
      return () => {
        audioElement.pause();
        audioElement.removeAttribute("src");
        audioElement.load();
      };
    }
  }, [getUserData()]);

  return (
    <audio
      ref={audioRef}
      src="https://www.jumbomail.me/JumbomailSound.mp3"
      style={{ display: "none" }}
    />
  );
};

export default AudioElement;
